<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
    <div class="vx-row">
      <div class="w-full">
        <div
          slot="no-body"
          class="tabs-container inventory_tabSec pt-6"
          id="view-customer-tab"
        >
          <div>
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="enumConfig"
                :description="false"
                search
                @selected="openView"
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("system.label.ENUM") }}
                  </div>
                  <!-- <div class="mr-2 mb-1 order-1">
                        <vs-button
                          icon-pack="feather"
                          icon="icon-plus"
                          @click="$router.push('/createEnum').catch(() => {})"
                          size="small"
                          >{{ $t("Create ENUM") }}</vs-button
                        >
                      </div> -->
                </template>
                <template slot="thead">
                  <th>{{ $t("system.label.ENUM_Name") }}</th>
                  <!-- <th>{{ $t("ENUM Id") }}</th>
                      <th>{{ $t("ENUM Property") }}</th>
                      <th>{{ $t("ENUM Value") }}</th>
                      <th>{{ $t("system.label.Actions") }}</th> -->
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="enumData"
                    v-for="(enumData, index) in data"
                  >
                    <vs-td :data="enumData.name">{{ enumData.name }}</vs-td>
                    <!-- <vs-td :data="enumData.id">{{ enumData.id }}</vs-td>
                        <vs-td :data="enumData.type">{{ enumData.type }}</vs-td>
                        <vs-td :data="enumData.value">{{
                          enumData.value
                        }}</vs-td>

                        <vs-td class="whitespace-no-wrap">
                          <feather-icon
                            icon="EditIcon"
                            title="edit"
                            class="text-warning"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                            @click.stop="editEventActionData(enumData.id)"
                          />
                        </vs-td> -->
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      editGlobalConfigurationValue: false,
      editValueConfig: "",
      editPaymentGatwayConfigPopup: false,
      createConfigurationPopup: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      valuesPair: {},
      valuesPairKeys: "",
      showKey: "",
      showValue: "",
      keyValues: [],
      enabledOptions: [true, false],
      idEditPaymentConfig: "",
      activeTab: 0,
      name: "",
      enabled: "",
      value: "",
      module: "",
      description: "",
    };
  },
  components: {
    AtomSpinner,
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      enumConfig: (state) => state.configuration.enumConfig,
    }),
  },
  methods: {
    async getEnumList() {
      this.loading = true;
      try {
        await this.$store.dispatch("configuration/fetchEnumList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    openView(enumConfig) {
      this.$router.push({
        name: "View Enum",
        params: { name: enumConfig.name },
      });
    },
    editEventActionData(id) {
      this.$router.push(`/editEventAction/${id}`);
    },
  },
  mounted() {
    this.getEnumList();
  },
};
</script>
<style scoped>
.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}
.width15 {
  max-width: 15%;
  word-break: break-all;
}
.width20 {
  max-width: 20%;
  word-break: break-all;
}
.button-container {
  display: flex;
  justify-content: flex-end;
}
.list-heading1 {
  font-size: 22px;
  font-weight: 500;
}
</style>
